import { render } from "./Mixture.vue?vue&type=template&id=45c2da8b&scoped=true"
import script from "./Mixture.vue?vue&type=script&lang=js"
export * from "./Mixture.vue?vue&type=script&lang=js"

import "./Mixture.vue?vue&type=style&index=0&id=45c2da8b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c2da8b"]])

export default __exports__